import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { Features } from '../../../business-entities/step.class';
import { VerifiedCustomer } from '../../../business-entities/verified-customer.interface';
import { WidgetCustomerVehicleDetails } from '../../../business-entities/widget-customer-vehicle-details-model';
import { FindCarDataService } from '../../../data-services/find-car-data.service';
import { CommonService } from '../../../services/commom.service';
import { CultureLocaleService } from '../../../services/culture-locale.service';
import * as CommonEnums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { CreateAppointmentViewModel } from './../../../business-entities/create-appointment-view-model.interface';
import { ContactInfoSections } from './../../../business-entities/customer-contact-sections.interface';
import { AppointmentService } from './../../../business-services/appointment.service';
import * as Constants from './../../../utils/contstants';
import * as Enums from './../../../utils/enums';
import { TermNConditionComponent } from './term-n-condition/term-n-condition.component';
import { UploadDocumentRequestModel } from '../../../../../../Autofacets-Core/src/app/business-entities/upload-document-request-model';
import { CountryISO } from 'ngx-intl-tel-input-gg';

@Component({
  selector: 'app-contact',
  templateUrl: 'contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  private readonly sectionConstants = Constants.contactInfoSectionConstant;
  contactFormDetails: FormGroup;
  regOtpSection = false;
  isCustomerValidated: boolean;
  mobileNo: string;
  mobileCode: string;
  userAuthMobilecode?: string;
  userNomineeMobilecode?: string;
  base64Image: string;
  successMsg: boolean = false;
  OTP: string = '';
  appData: any;
  isOTP: boolean = true;
  TCLink: boolean = true;
  TCUrl: string = '';
  currentLanguage: string;
  mobileNumberFlag: string;
  features: Features[] = [];
  sections: ContactInfoSections;
  mobileNumber: any;
  isOtpVerified: boolean = false;
  readOnlyNomineeMobile: boolean = false;
  timerOn: boolean = true;
  minute: any
  second: any
  timeout: boolean = false;
  timeoutMessage: string;
  selectedCustomerVehicleDetails: WidgetCustomerVehicleDetails;
  customerDocuments: UploadDocumentRequestModel[];
  CountryISO = CountryISO;
  isInitialLoad: boolean= true;
  isInitialLoadMobilecode: boolean= true;
  onlyCountries: string[] = [];
  countryDialCodes: any[]= [];
  selectedCountryISOMobile= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  selectedCountryISOMobileNumber= this.cultureLocaleService.getLocale() || CountryISO.Norway;  
  selectedCountryISONomineeMob= this.cultureLocaleService.getLocale() || CountryISO.Norway;

  @Output() openAnotherPanelRequest = new EventEmitter<string>();
  @ViewChild('otpTimer', { static: false }) otpTimer: ElementRef;

  constructor(
    public commonService: CommonService,
    private readonly appointmentService: AppointmentService,
    private readonly router: Router,
    private readonly spinner: NgxSpinnerService,
    private readonly translateService: TranslateService,
    private readonly toastr: ToastrService,
    private readonly vehicleService: FindCarDataService,
    private readonly currentLanguageService: CurrentLanguage,
    private readonly secureStorage: SecureStorage,
    private readonly cultureLocaleService: CultureLocaleService,
    private readonly modelService: NgbModal,
    private readonly findCarDataSevice: FindCarDataService

  ) {
    this.sections = {
      registrationNumberSection: true,
      customerDetailSection: false,
      regOtpSection: false
    };
  }

  ngOnInit(): void {
    this.onlyCountries= Constant.OnlyCountry;
    this.countryDialCodes= Constant.CountryDialCodes;
    this.selectedCustomerVehicleDetails = this.commonService.getSelectedCustomerVehicleDetails();
    this.InitializeForm();
    this.initializeMobileNumber();

    this.isOtpVerified = this.commonService.checkvalidateOtp();
    if (this.isOtpVerified) {
      this.sections = {
        registrationNumberSection: false,
        customerDetailSection: true,
        regOtpSection: false
      };
    }
  }

  initializeMobileNumber() {
    if (this.commonService.checkAddedCustomerDeatils()) {
      this.userAuthMobilecode = this.userAuthMobilecode ?? this.commonService.getUserAuthMobileCode();
      this.mobileNumber = this.commonService.getUserAuthMobile();
    }
    this.userAuthMobilecode = this.userAuthMobilecode ?? this.commonService.getUserAuthMobileCode();
    this.mobileNumber = this.commonService.getUserAuthMobile();
    this.telCustomerInputObject();
  }

  async generateAndSendOtp(): Promise<void> {
    this.currentLanguageService.currentLanguage.subscribe(x => {
      this.currentLanguage = x
    });
    if (this.secureStorage.getKeyData('feature')) {
      this.features = this.secureStorage.getKeyData('feature');
      if (this.features?.length > 0) {
        this.isOTP = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.OTP)?.isActive
      }
    }
    if (this.isOTP) {
      const model = {
        MobileCode: this.userAuthMobilecode,
        MobileNo: this.mobileNumber?.number ? this.mobileNumber.number.toString().replace(/\s+/g, '') : this.mobileNumber,
        LanguageCode: this.currentLanguage,
      }
      const invalidOTP = this.translateService.instant("lblOTPsend")
      const OTPExpire = this.translateService.instant("lblOTPNotsend")
      await this.findCarDataSevice.AddMobileOTPDetails(model).then((res) => {
        if (res.responseObject.result) {
          this.toastr.success(invalidOTP);
          this.resetAndCallOtpTimer();
          this.changeSection(this.sectionConstants.regOtpSection);
        }
        else {
          this.toastr.error(OTPExpire);
          this.timeout = true;
          this.changeSection(this.sectionConstants.regOtpSection);
        }
        this.spinner.hide();
      })
    }
    else {
      await this.verifyOtp();
    }
    await this.resetAndCallOtpTimer();
    this.spinner.hide();
  }
  onCarSingleSelectionFormSubmit(form: NgForm): void {
    if (this.mobileNumberFlag != 'true') {
      this.spinner.show();
      this.currentLanguageService.currentLanguage.subscribe(x => {
        this.currentLanguage = x
      });
      if (this.isOTP) {     
        this.generateAndSendOtp();
      }
      else {
        this.resetAndCallOtpTimer();
        this.changeSection(this.sectionConstants.regOtpSection);
        this.spinner.hide();
      }
    } else if (form.value.mobileNo == '' || isNullOrUndefined(form.value.mobileNo)) {
        let errorMsg = this.translateService.instant('lblPleaseEnterYourMobileNumber')
        this.toastr.error(errorMsg);
      } else {
        let errorMsg = this.translateService.instant('lblPleaseEnterCorrectMobileNumber')
        this.toastr.error(errorMsg);
      }

  }


  goToPrevious(): void {
    this.openAnotherPanelRequest.emit(Enums.PanelIds.Panel4);
  }

  InitializeForm(): void {
    if (this.secureStorage.getKeyData('feature')) {
      this.features = this.secureStorage.getKeyData('feature');
      if (this.features?.length > 0) {
        this.isOTP = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.OTP)?.isActive
        this.TCLink = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.TCLINK)?.isActive
        if (this.TCLink) {
          this.TCUrl = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.TCLINK)?.serviceUrl1;
        }
      }
    }
    this.isCustomerValidated = this.commonService.checkCustomerValidtion();
    this.contactFormDetails = new FormGroup({
      Name: new FormControl(null, []),
      MobileNumber: new FormControl(null, []),
      NomineeName: new FormControl(null, []),
      NomineeMobileNumber: new FormControl(null),
      UserPrivacyAccept: new FormControl(null, []),
      UserConsent: new FormControl(null, []),
      PinCode: new FormControl(null, []),
      Email: new FormControl(null, []),
    });
    this.appData = this.commonService.getAppData();
    this.contactFormDetails.patchValue({
      MobileNumber: this.selectedCustomerVehicleDetails.cusT_MOBILE_NO ?? this.selectedCustomerVehicleDetails.CUST_MOBILE_NO,
      Name: this.selectedCustomerVehicleDetails.cusT_NAME ?? this.selectedCustomerVehicleDetails.CUST_NAME,
      PinCode: this.selectedCustomerVehicleDetails.pincode ?? this.selectedCustomerVehicleDetails.PINCODE,
      Email: this.selectedCustomerVehicleDetails.cusT_EMAILID ?? this.selectedCustomerVehicleDetails.CUST_EMAILID
    });
    this.contactFormDetails.controls.MobileNumber.disable();
    this.contactFormDetails.controls.Name.disable();
  }

  get ContactFormControls(): any {
    return this.contactFormDetails.controls;
  }
  onchange(event, form: NgForm) {
    let isnum = /^\d+$/.test(event.target.value);
    if (!isnum) {
      this.mobileNumber = ''; event.preventDefault();
      let errorMsg = this.translateService.instant('lblEnterValidMobile')
      this.toastr.error(errorMsg);
      form.resetForm();
    }
  }
  async verifyOtp(): Promise<void> {
    // verify OTP
    // if(this.OTP.length === 6 && (this.isOTP || this.OTP == '123456')){
    if (this.OTP?.length === 6 && (this.isOTP)) {
      // this.spinner.show();
      const invalidOTP = this.translateService.instant("lblInvalidOTP")
      const OTPExpire = this.translateService.instant("lblOTPExpire")
      const model =
      {
        MobileCode: this.mobileNumber?.dialCode,
        MobileNumber: this.mobileNumber?.number ? this.mobileNumber.number.toString().replace(/\s+/g, '') : this.mobileNumber,
        Otp: this.OTP,
      }
      await this.appointmentService.ValidateMobileOtp(model).then((res) => {
        if (res.responseObject.result.mobileNumber) {
          let verifiedCustdetails = res.responseObject.result as VerifiedCustomer;
          this.commonService.validateCustomer();
          if (this.mobileNumber != verifiedCustdetails.mobileNumber || this.userAuthMobilecode != verifiedCustdetails.mobileCode) {
            this.mobileCode = verifiedCustdetails.mobileCode;
            this.contactFormDetails.patchValue({
              NomineeMobileNumber: this.mobileNumber?.number ? this.mobileNumber.number.toString().replace(/\s+/g, '') : this.mobileNumber,
            });
            this.userNomineeMobilecode = this.userAuthMobilecode;
            this.telInputObject();
            this.readOnlyNomineeMobile = true;
          }
          else {
            this.mobileCode = this.userAuthMobilecode;
          }
          this.timerOn = false;
          this.OTP = '';
          this.changeSection(this.sectionConstants.customerDetailSection);
          this.spinner.hide();
        }
        else if (res.responseObject.result.errorCode === CommonEnums.ErrorCodes.InvalidOTP) {
          this.OTP = '';
          this.toastr.error(invalidOTP);
          this.spinner.hide();
        }
        else if (res.responseObject.result.errorCode === CommonEnums.ErrorCodes.OTPTimeOut) {
          this.OTP = '';
          this.toastr.error(OTPExpire);
          this.spinner.hide();
        }
      })
    }
    else {
      const invalidOTP = this.translateService.instant("lblInvalidOTP")
      this.toastr.error(invalidOTP)
    }
  }

  ResendOTP() {
    this.timerOn = false;
    this.currentLanguageService.currentLanguage.subscribe(x => {
      this.currentLanguage = x
    });
    const appData = this.commonService.getAppData();
    if (this.isOTP) {
      const model = {
        CustomerGuid: this.selectedCustomerVehicleDetails.customerGuid,
        PhoneNo: '+' + this.userAuthMobilecode + (this.mobileNumber?.number ? this.mobileNumber.number.toString().replace(/\s+/g, '') : this.mobileNumber),
        DealerName: appData.selectedDealer.dealerName,
        LanguageCode: this.currentLanguage,
        DealerId: appData.selectedDealer.dealerId
      }
      const invalidOTP = this.translateService.instant("lblOTPResend")
      const OTPExpire = this.translateService.instant("lblOTPNotResend")
      this.vehicleService.AddCustomerMobile(model).then((res) => {
        if (res.responseObject.result) {
          this.resetAndCallOtpTimer();
          this.toastr.success(invalidOTP)
        }
        else {
          this.toastr.error(OTPExpire)
        }
      })
    }
    else {
      this.successMsg = true;
      setTimeout(() => this.successMsg = false, 3000);
      this.resetAndCallOtpTimer();
    }
  }

  resetAndCallOtpTimer() {
    this.minute = '0';
    this.second = '0';
    this.timerOn = true;
    this.timeout = false;
    this.timer(+(EnvSetting.otpExpireTime) * 60);
  }
  mask(phrase: string) {
    let length = phrase.length;
    let toBeReplaced = phrase.slice(4, length);
    let replacedtext = Array(length - 4).join("X")
    return phrase.replace(toBeReplaced, replacedtext);
  }

  onSubmit(): void {
    if (this.contactFormDetails.invalid) {
      const NoContactPersonName = this.translateService.instant("lblNoContactPersonName")
      const OTPExTnCNotCheckedpire = this.translateService.instant("lblTnCNotChecked")
      if (this.readOnlyNomineeMobile) {
        if (!this.ContactFormControls.NomineeName.value) {

          this.toastr.error(NoContactPersonName);
        }
        else if (!this.ContactFormControls.UserPrivacyAccept.value) {
          this.toastr.error(OTPExTnCNotCheckedpire);
        }
      }
      else {
        this.toastr.error(OTPExTnCNotCheckedpire);
      }
      return;
    }
    this.updateContactDetails();
    if (this.readOnlyNomineeMobile)
      this.selectedCustomerVehicleDetails.CUST_NAME = this.ContactFormControls.NomineeName.value;
    // post call
    this.spinner.show();
    const viewModel = this.MapToViewModel();
    this.appointmentService.CreateAppointment(viewModel)
      .then((result) => {

        if (result.responseObject && result.responseObject.errorCount > 0) {
          const errorCode = result.responseObject.result ? result.responseObject.result.errorCode : null;

          if (errorCode === CommonEnums.ErrorCodes.ParamNotFoundErrorCode ||
            errorCode === CommonEnums.ErrorCodes.CreateAppointmentErrorCode) {
            this.toastr.error(CommonEnums.ToastrMessages.CreateAppointmentFailed);
          }
        }
        else {
          const isCreated = result.responseObject.result as { appointmentGuid: string, isSlotExist: boolean };
          if (isCreated.isSlotExist && isCreated.appointmentGuid != null) {
            this.commonService.setAppointmentCreated(isCreated.appointmentGuid);
            this.commonService.stopExpireTimer();
            this.router.navigate([Enums.AppRoutes.Summary]);
          }
          else if (!isCreated.isSlotExist) {
            let msg = this.translateService.instant("lblSlotNotExists")
            this.toastr.error(msg);
          }
          else {
            this.toastr.error(CommonEnums.ToastrMessages.CreateAppointmentFailed);
          }
        }
        this.spinner.hide();
      }, _error => {
        this.spinner.hide();
      });
  }
  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }
  MapToViewModel(): CreateAppointmentViewModel {
    this.customerDocuments = this.commonService.getAllDocument();
    this.currentLanguageService.currentLanguage.subscribe(x => {
      this.currentLanguage = x
    });
    const appData = this.commonService.getAppData();
    const allSelectedServices: { Id?: number, Description?: string, FromRecommended: boolean }[] = appData.selectedService.map(x => {
      let description = x.description;
      if (x.id === Enums.ServiceIds.BodyRepair && appData.damageDescription) {
        description = appData.damageDescription;
      } else if (x.id === Enums.ServiceIds.StoneChip && appData.stoneChipInput) {
        description = appData.stoneChipInput;
      } else if (x.id === Enums.ServiceIds.ServiceId && appData.carCode) {
        description = `servicecode : ${appData.carCode}`;
      }
      return {
        Id: x.id, Description: description, FromRecommended: false, isAdditionalCustomerComment: x.isAdditionalCustomerComment, additionalCustomerComment: x.additionalCustomerComment
        , selectedWarningLightId: x.isWarningLight ? x.selectedWarningLight : null
      };
    });
    if (appData.selectedAdditionService) {
      Object.keys(appData.selectedAdditionService).forEach(key => {
        const val = appData.selectedAdditionService[key];
        const description = appData.dealerRecommendedService?.find(x => x.serviceId === +key)?.description;
        const isAdditionalCustomerComment = appData.dealerRecommendedService?.find(x => x.serviceId === +key)?.isAdditionalCustomerComment
        const additionalCustomerComment = appData.dealerRecommendedService?.find(x => x.serviceId === +key)?.additionalCustomerComment
        const selectedWarningLightId = appData.dealerRecommendedService?.find(x => x.serviceId === +key)?.selectedWarningLightId
        if (val) {
          const temp = {
            Id: +key,
            Description: description,
            FromRecommended: true,
            isAdditionalCustomerComment: isAdditionalCustomerComment,
            additionalCustomerComment: additionalCustomerComment,
            selectedWarningLightId: selectedWarningLightId
          };
          allSelectedServices.push(temp);
        }
      });
    }
    if (appData.otherIssuesInput && appData.otherIssuesInput.trim().length > 0) {
      allSelectedServices.push({ Description: appData.otherIssuesInput.trim(), FromRecommended: false });
    }

    let generateWorkOrderNoPlannerSide = false;
    let integrationWithDMS = false;
    let realtimeDmsSyncAppointment = true;
    if (this.secureStorage.getKeyData('feature')) {
      this.features = this.secureStorage.getKeyData('feature');
      if (this.features?.length > 0) {
        generateWorkOrderNoPlannerSide = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.GWoNoPlannerSide)?.isActive
        integrationWithDMS = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.DMS)?.isActive
        realtimeDmsSyncAppointment = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.RTDSA)?.isActive
      }
    }
    let registrationDate = (this.selectedCustomerVehicleDetails?.registrationDate) ? this.selectedCustomerVehicleDetails?.registrationDate : this.selectedCustomerVehicleDetails.DFRegistrationDate
    const model: CreateAppointmentViewModel = {
      CustomerVehicleDetails: this.selectedCustomerVehicleDetails,
      DealerDetails: appData.selectedDealer,
      Service: allSelectedServices,
      DeliverCarWithinBusinessHours: appData.deliverCarWithinBusinessHours,
      PickupCarWithinBusinessHours: appData.pickupCarWithinBusinessHours,
      SelectedDate: appData.appointmentDateTime,
      RentalCar: appData.selectedRentalCar,
      StoneChipInput: appData.stoneChipInput,
      AdditionalComments: appData.additionalComments,
      AvailCheckInFacility: appData.availCheckInFacility,
      BodyBrokenImage: appData.damageIconImage,
      DamageDescription: appData.damageDescription,
      UserAuthMobile: appData.userAuthMobile,
      Mileage: appData.mileage,
      OtherIssuesInput: appData.otherIssuesInput,
      CarCode: appData.carCode,
      IsPickUpDropOffService: appData.isPickupDropOffServiceSelection,
      PickUpDateTime: appData.pickupDatetime,
      LanguageCode: this.currentLanguage,
      TimeSlotSelection: (appData.timeSlotSection === undefined) ? false : appData.timeSlotSection,
      IsDifferentCustomer: this.readOnlyNomineeMobile,
      IsTnCAccepted: this.ContactFormControls.UserPrivacyAccept.value,
      GenerateWorkOrderNoPlannerSide: generateWorkOrderNoPlannerSide,
      ModuleId: CommonEnums.ModuleNames.Appointment,
      IntegrationWithDMS: integrationWithDMS,
      AppointmentType: "Order",
      GenericRentalCarType: appData.isGenericRentalCar ? appData.genericRentalCar.typeId : 0,
      GenericRentalCarPrice: appData.isGenericRentalCar ? appData.genericRentalCar.price : '0',
      GenericRentalCarTypeName: appData.isGenericRentalCar ? appData.genericRentalCar.type : '',
      IsGenericRentalCar: appData.isGenericRentalCar,
      RealtimeDmsSyncAppointment: realtimeDmsSyncAppointment,
      UserConsent: !!this.ContactFormControls.UserConsent.value,
      PlanningStartDate: (appData.planningStartTime === undefined || appData.planningStartTime === null) ? null : appData.planningStartTime,
      PlanningEndDate: (appData.planningEndTime === undefined || appData.planningEndTime === null) ? null : appData.planningEndTime,
      MechanicId: appData.mechanicId,
      ReserveSlotId: appData.reserveSlotId,
      SelectedStartTime: appData.selectedStartTime,
      PlanningSlots: appData.planningSlots,
      CalendarNumber: appData.calenderNumber,
      CustomerDocuments: (this.customerDocuments) ? this.customerDocuments : [],
      VehicleAge: Utility.monthDiff((registrationDate) ? new Date(registrationDate) : new Date(), new Date())
    };
    return model;
  }

  updateContactDetails(): void {
    this.commonService.addNomineeDetails(this.ContactFormControls.NomineeName.value, this.ContactFormControls.NomineeMobileNumber.value?.number ? this.ContactFormControls.NomineeMobileNumber.value.number.toString().replace(/\s+/g, '') : this.ContactFormControls.NomineeMobileNumber.value, this.userNomineeMobilecode);
  }

  telInputObject() {
    if (this.userNomineeMobilecode) {
      let countryCode = this.getCountryCodeByDialCode(this.userNomineeMobilecode);
      this.selectedCountryISONomineeMob= countryCode || this.cultureLocaleService.getLocale();
    }
    else {
      this.selectedCountryISONomineeMob= this.cultureLocaleService.getLocale();
    }
  }

  onCountryChange(obj) {
    if (this.isInitialLoadMobilecode) {
    this.telInputObject();
    this.userNomineeMobilecode = this.userNomineeMobilecode || obj.dialCode;
    this.isInitialLoadMobilecode = false;
    } else {
      this.userNomineeMobilecode = obj.dialCode;
    }
  }

  telCustomerInputObject() {
    if (this.userAuthMobilecode) {
      let countryCode = this.getCountryCodeByDialCode(this.userAuthMobilecode);
      this.selectedCountryISOMobileNumber= countryCode || this.cultureLocaleService.getLocale();
    }
    else {
      let countryCode = this.getCountryCodeByDialCode(this.selectedCustomerVehicleDetails?.DIAL_CODE);
      this.selectedCountryISOMobileNumber= countryCode || this.cultureLocaleService.getLocale();
    }
  }

  telRegNoInputObject() {
    if (this.userAuthMobilecode) {
      let countryCode = this.getCountryCodeByDialCode(this.userAuthMobilecode);
      this.selectedCountryISOMobile= countryCode || this.cultureLocaleService.getLocale();
    }
    else {
      let countryCode = this.getCountryCodeByDialCode(this.selectedCustomerVehicleDetails?.DIAL_CODE);
      this.selectedCountryISOMobile= countryCode || this.cultureLocaleService.getLocale();
    }
  }

  getCountryCodeByDialCode(dialCode: any) {
    const country = this.countryDialCodes.find(c => c.dialCode === dialCode);
    return country ? country.countryCode : null;
  }

  onRegNoCountryChange(obj) {
    if (this.isInitialLoad) {
    this.telRegNoInputObject();
    this.userAuthMobilecode = this.userAuthMobilecode || obj.dialCode;
    this.isInitialLoad = false;
    } else {
      this.userAuthMobilecode = obj.dialCode;
    }
    this.commonService.addUserAuthMobileCode(this.userAuthMobilecode);
    this.selectedCustomerVehicleDetails.DIAL_CODE = this.userAuthMobilecode;
  }

  changeSection(key: string): void {
    Object.keys(this.sections).forEach(x => {
      if (x === key) {
        this.sections[x] = true;
      } else {
        this.sections[x] = false;
      }
    });
  }


  validateMobileNumberField(flag: string): void {
    this.mobileNumberFlag = flag ? 'false' : 'true';
  }

  onChangePhoneNo(): void {
    this.OTP = '';
    this.timerOn = false;
    this.changeSection(this.sectionConstants.registrationNumberSection);
  }

  openTnCPopup() {
    this.modelService.open(TermNConditionComponent);
  }

  timer(remaining: any) {
    this.minute = Math.floor(remaining / 60);
    this.second = remaining % 60;

    this.minute = this.minute < 10 ? '0' + this.minute : this.minute;
    this.second = this.second < 10 ? '0' + this.second : this.second;
    this.otpTimer.nativeElement.innerHTML = this.minute + ':' + this.second;
    remaining -= 1;

    if (remaining >= 0 && this.timerOn) {
      setTimeout(() => {
        this.timer(remaining);
      }, 1000);
      return;
    }

    if (!this.timerOn) {
      // Do validate stuff here
      return;
    }

    // Do timeout stuff here
    this.timeout = true;
    const OTPExpire = this.translateService.instant("lblOTPExpire")
    this.toastr.error(OTPExpire);
  }
  onMobileNoChange(){
    if(this.contactFormDetails.get('NomineeMobileNumber').value){
      let len= this.contactFormDetails.get('NomineeMobileNumber').value.number.toString().replace(/\s+/g, '').length;
      if(len<8 || len>11){
        this.contactFormDetails.get('NomineeMobileNumber').setValidators([Validators.pattern(/^\d+$/)]);
        this.contactFormDetails.get('NomineeMobileNumber').updateValueAndValidity();
      } else {
        this.contactFormDetails.get('NomineeMobileNumber').setValidators([]);
        this.contactFormDetails.get('NomineeMobileNumber').updateValueAndValidity();
      }
    }
  }

  ngOnDestroy() {
    this.timerOn = false;
  }

}

